var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankIconnew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39_3927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.66675 7.71239C3.66675 6.91494 3.98834 6.42622 4.65383 6.05586L7.39333 4.5313C8.82881 3.73244 9.54656 3.33301 10.3334 3.33301C11.1203 3.33301 11.838 3.73244 13.2735 4.5313L16.013 6.05586C16.6785 6.42622 17.0001 6.91494 17.0001 7.71239C17.0001 7.92863 17.0001 8.03675 16.9765 8.12564C16.8524 8.59264 16.4292 8.66634 16.0206 8.66634H4.64627C4.23759 8.66634 3.81443 8.59264 3.69036 8.12564C3.66675 8.03675 3.66675 7.92863 3.66675 7.71239Z",
    stroke: "#334155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3307 6.66602H10.3367",
    stroke: "#334155",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 8.66602V14.3327M7.66667 8.66602V14.3327",
    stroke: "#334155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 8.66602V14.3327M15.6667 8.66602V14.3327",
    stroke: "#334155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 14.333H5.66675C4.56218 14.333 3.66675 15.2284 3.66675 16.333C3.66675 16.5171 3.81599 16.6663 4.00008 16.6663H16.6667C16.8508 16.6663 17.0001 16.5171 17.0001 16.333C17.0001 15.2284 16.1047 14.333 15.0001 14.333Z",
    stroke: "#334155"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39_3927"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankIconnew);
export default __webpack_public_path__ + "static/media/bankIconnew.b56935834414a92dae675d5006f4f5d7.svg";
export { ForwardRef as ReactComponent };